import React from "react";
import useDraggableBase from "./base.js";
var useDraggable = function useDraggable(_ref) {
  var navigation = _ref.navigation;
  var onDrag = React.useCallback(function (_ref2) {
    var distance = _ref2.distance,
      target = _ref2.target;
    var relativeDistance = distance / target.clientWidth;
    navigation.drag(relativeDistance);
  }, [navigation]);
  return useDraggableBase({
    onDrag: onDrag,
    onDragEnd: navigation.adjust
  });
};
export default useDraggable;